import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

import { computed, ref, useId, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableCheckbox',
  props: {
    isChecked: { type: Boolean },
    inputId: { default: undefined },
    isIndeterminate: { type: Boolean },
    size: { default: 16 }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "7cf5c675": (sizePx.value)
}))

const generatedId = useId();

const props = __props;
const emits = __emit;

const inputRef = ref<HTMLInputElement | null>(null);
const isChecked = ref<boolean>(false);

const sizePx = computed(() => `${props.size}px`);
const inputId = computed(() => props.inputId ?? generatedId);

watch(
  () => props.isChecked,
  (newValue) => {
    isChecked.value = newValue;
  },
  { immediate: true }
);

watch(
  [() => props.isIndeterminate, inputRef],
  ([newValue, input]) => {
    if (input) input.indeterminate = !!newValue;
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    id: inputId.value,
    ref_key: "inputRef",
    ref: inputRef,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChecked).value = $event)),
    type: "checkbox",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (emits('change', isChecked.value)))
  }, null, 40, _hoisted_1)), [
    [_vModelCheckbox, isChecked.value]
  ])
}
}

})